// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // commonurl: 'http://120.138.9.165:8843/CDIServices/rest/orderprocessingservice/',
  // imageUrl: 'http://120.138.9.165:8843/CDIServices/'
  // commonurl: 'http://10.0.0.25:9595/CDIServices/rest/orderprocessingservice/',
  // imageUrl: 'http://10.0.0.25:9595/CDIServices/'
  // commonurl: 'http://10.0.0.42:9595/CDIServices/rest/orderprocessingservice/',
  // imageUrl: 'http://10.0.0.42:9595/CDIServices/'
  // commonurl: 'http://192.168.1.23:9595/CDIServices/rest/orderprocessingservice/',
  // imageUrl: 'http://192.168.1.23:9595/CDIServices/'
  commonurl: 'http://192.30.41.134:9595/CDIServices/rest/orderprocessingservice/',
  imageUrl: 'http://192.30.41.134:9595/CDIServices/'
  // commonurl: 'http://10.0.0.43:9595/CDIServices/rest/orderprocessingservice/',
  // imageUrl: 'http://10.0.0.43:9595/CDIServices/'
  // commonurl: 'http://76.72.245.174:8810/CDIServices/rest/orderprocessingservice/',
  // imageUrl: 'http://76.72.245.174:8810/CDIServices/'
  // commonurl: 'http://10.0.0.42:8830/CDIServices/rest/orderprocessingservice/',
  // imageUrl: 'http://10.0.0.42:8830/CDIServices/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts